var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFaqCollapse = function SvgFaqCollapse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 28"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u7EC4 4808"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\u7EC4 2279",
    fill: "#84fcfc"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u692D\\u5706 73",
    d: "M14.001 1a13 13 0 0 0-9.192 22.192A13 13 0 0 0 23.193 4.808 12.915 12.915 0 0 0 14.001 1m0-1a14 14 0 1 1-14 14 14 14 0 0 1 14-14Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\u8DEF\\u5F84 5024",
    d: "M19.634 15H8.989v-1h10.645Z"
  })))));
};
export default SvgFaqCollapse;